import * as actionTypes from "../constants/actionTypes";
import { Entities } from "../interfaces";
import { Item } from "../reducers/items";

export interface SearchItemsAction {
  type: "SEARCH_ITEMS";
}
export interface SearchItemsSuccessAction {
  type: "SEARCH_ITEMS_SUCCESS";
  payload: {
    entities: Entities;
    page: number;
    total: number;
    filters: {
      categories: Array<string>;
      item_types: Array<string>;
      markets: Array<string>;
      properties: Array<string>;
      tags: Array<string>;
    };
    userCanEdit: boolean;
    userCanShare: boolean;
  };
}
export interface SearchItemsErrorAction {
  type: "SEARCH_ITEMS_ERROR";
  payload: { error: string; status: number };
}
export interface GetNextPageForItemsAction {
  type: "GET_NEXT_PAGE_FOR_ITEMS";
  payload: { page: number };
}
export interface ResetPageForItemsAction {
  type: "RESET_PAGE_FOR_ITEMS";
}
export interface SelectItemAction {
  type: "SELECT_ITEM";
  payload: { item: Item | null | undefined };
}
export interface GetItemByIdAction {
  type: "GET_ITEM_BY_ID";
  payload: { itemId: string };
}
export interface GetItemByIdSuccessAction {
  type: "GET_ITEM_BY_ID_SUCCESS";
  payload: { item: Item | null | undefined };
}
export interface GetItemByIdErrorAction {
  type: "GET_ITEM_BY_ID_ERROR";
  payload: { error: string; status: number };
}
export interface ToggleEditModeAction {
  type: "TOGGLE_EDIT_MODE";
}
export interface UnpublishItemAction {
  type: "UNPUBLISH_ITEM";
  payload: { itemId: string };
}
export interface UnpublishItemSuccessAction {
  type: "UNPUBLISH_ITEM_SUCCESS";
  payload: { itemId: string };
}
export interface UnpublishItemErrorAction {
  type: "UNPUBLISH_ITEM_ERROR";
  payload: { error: string; status: number };
}
export interface EditTagsForItemAction {
  type: "EDIT_TAGS_FOR_ITEM";
  payload: {
    added: Array<string>;
    removed: Array<string>;
    itemId: string;
  };
}
export interface EditTagsForItemSuccessAction {
  type: "EDIT_TAGS_FOR_ITEM_SUCCESS";
  payload: { tags: Array<string>; itemId: string };
}
export interface EditTagsForItemErrorAction {
  type: "EDIT_TAGS_FOR_ITEM_ERROR";
  payload: { error: string; status: number };
}
export interface ShowEditModalAction {
  type: "SHOW_EDIT_MODAL";
  payload: { visible: boolean; item: Item };
}

export type Action =
  | SearchItemsAction
  | SearchItemsSuccessAction
  | SearchItemsErrorAction
  | GetNextPageForItemsAction
  | ResetPageForItemsAction
  | SelectItemAction
  | GetItemByIdAction
  | GetItemByIdSuccessAction
  | GetItemByIdErrorAction
  | UnpublishItemAction
  | UnpublishItemSuccessAction
  | UnpublishItemErrorAction
  | EditTagsForItemAction
  | EditTagsForItemSuccessAction
  | EditTagsForItemErrorAction
  | ShowEditModalAction
  | ToggleEditModeAction;

export function searchItems(): Action {
  return {
    type: actionTypes.SEARCH_ITEMS
  };
}

export function searchItemsSuccess(result: {
  entities: Entities;
  page: number;
  total: number;
  filters: {
    categories: Array<string>;
    item_types: Array<string>;
    markets: Array<string>;
    properties: Array<string>;
    tags: Array<string>;
  };
  userCanEdit: boolean;
  userCanShare: boolean;
}): Action {
  return {
    type: actionTypes.SEARCH_ITEMS_SUCCESS,
    payload: result
  };
}

export function searchItemsError(error: string, status: number): Action {
  return {
    type: actionTypes.SEARCH_ITEMS_ERROR,
    payload: {
      error,
      status
    }
  };
}

export function getNextPageForItems(page: number): Action {
  return {
    type: actionTypes.GET_NEXT_PAGE_FOR_ITEMS,
    payload: {
      page
    }
  };
}

export function resetPageForItems(): Action {
  return {
    type: actionTypes.RESET_PAGE_FOR_ITEMS
  };
}

export function selectItem(item: Item | null | undefined): Action {
  return {
    type: actionTypes.SELECT_ITEM,
    payload: {
      item
    }
  };
}

export function getItemById(itemId: string): Action {
  return {
    type: actionTypes.GET_ITEM_BY_ID,
    payload: {
      itemId
    }
  };
}

export function getItemByIdSuccess(item: Item | null | undefined): Action {
  return {
    type: actionTypes.GET_ITEM_BY_ID_SUCCESS,
    payload: {
      item
    }
  };
}

export function getItemByIdError(error: string, status: number): Action {
  return {
    type: actionTypes.GET_ITEM_BY_ID_ERROR,
    payload: {
      error,
      status
    }
  };
}
/****** edit mode ******/

export function toggleEditMode(): Action {
  return {
    type: actionTypes.TOGGLE_EDIT_MODE
  };
}

export function unpublishItem(itemId: string): Action {
  return {
    type: actionTypes.UNPUBLISH_ITEM,
    payload: {
      itemId
    }
  };
}

export function unpublishItemSuccess(itemId: string): Action {
  return {
    type: actionTypes.UNPUBLISH_ITEM_SUCCESS,
    payload: {
      itemId
    }
  };
}

export function unpublishItemError(error: string, status: number): Action {
  return {
    type: actionTypes.UNPUBLISH_ITEM_ERROR,
    payload: {
      error,
      status
    }
  };
}

export function editTagsForItem(
  added: Array<string>,
  removed: Array<string>,
  itemId: string
): Action {
  return {
    type: actionTypes.EDIT_TAGS_FOR_ITEM,
    payload: {
      added,
      removed,
      itemId
    }
  };
}

export function editTagsForItemSuccess(
  tags: Array<string>,
  itemId: string
): Action {
  return {
    type: actionTypes.EDIT_TAGS_FOR_ITEM_SUCCESS,
    payload: {
      tags,
      itemId
    }
  };
}

export function editTagsForItemError(error: string, status: number): Action {
  return {
    type: actionTypes.EDIT_TAGS_FOR_ITEM_ERROR,
    payload: {
      error,
      status
    }
  };
}

export function showEditModal(visible: boolean, item: Item): Action {
  return {
    type: actionTypes.SHOW_EDIT_MODAL,
    payload: {
      visible,
      item
    }
  };
}
